module.exports = __webpack_public_path__ + "img/btn_service_close.f328066f.svg";